import UserAccounts from './containers/container';

export default UserAccounts;
